import useStore from "stores/index";
import getChatDisabled from "js/utils/chatStatusHelper";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { getClassroomIdForChat } from "../../../../utils/chatUtils";
import ChatButton from "../ChatButton";
import { useClassroomPolicyStore } from "stores/v2/classroomPolicyStore";

const ChatToolbarButton = (props) => {
	const [hasUnreadMessages, setHasUnreadMessages] = useState(false);

	const disabledChat = useMemo(() => {
		return getChatDisabled(props.classroom.sourceId);
	}, [props.classroom.sourceId]);

	useEffect(() => {
		const unsubMessageOverview = useStore.subscribe(
			(state) => state.chat.unreadMessagesCount,
			(newState) => {
				if (newState.data) {
					setHasUnreadMessages(
						Object.values(newState.data).some(
							(item) => item.hasUnreadMessages && item.classroomId === getClassroomIdForChat(props.classroom)
						)
					);
				}
			}
		);

		return () => {
			unsubMessageOverview();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const isChatEnabled = useClassroomPolicyStore.getState().isChatBlocked() === false;
	const isClassroomActive = useStore.getState().classroom.isActiveV2(props.classroom.sourceId);

	return (
		<ChatButton
			isChatActive={isClassroomActive && isChatEnabled}
			hasUnreadMessages={hasUnreadMessages}
			disabledChat={disabledChat}
			{...props}
		/>
	);
};

ChatToolbarButton.propTypes = {
	handleClick: PropTypes.func,
	classroom: PropTypes.object,
};

export default ChatToolbarButton;
